import Router from "@/helpers/router";

import {
  WHATS_NEW_AUDIENCES,
  WHATS_NEW_ICONS,
  WhatsNewEntryI,
} from "../lib/types";

const { CALLER, POD_LEAD, LGA, ADMIN } = WHATS_NEW_AUDIENCES;

/**
 * C-16 UI release (GLE-8406): shell, Calendar and content/copy updates.
 * Window: the release day (Saturday 2026-10-31, midnight ET) to release +
 * 14 days, so a weekend release still reaches weekday logins; each user sees
 * it on at most two ET days (DEFAULT_WHATS_NEW_MAX_DAYS, C16-D425).
 */
export const PAGE_UPDATES_2026_10_28: WhatsNewEntryI = {
  id: "2026-10-28-page-updates",
  startsAt: "2026-10-31T04:00:00.000Z",
  endsAt: "2026-11-14T05:00:00.000Z",
  title: {
    [CALLER]: "A clearer My Week",
    [POD_LEAD]: "A clearer My Week and Team Calendar",
    [LGA]: "A clearer Team Calendar and Pods",
    [ADMIN]: "Clearer Team and Admin pages",
  },
  sections: [
    {
      id: "my-week",
      audiences: [CALLER, POD_LEAD],
      icon: WHATS_NEW_ICONS.CALENDAR,
      title: "My Week",
      items: [
        "Your page title now sits with your week, with simpler labels throughout.",
      ],
      link: { label: "Open My Week", href: Router.myWeek() },
    },
    {
      id: "calendar",
      audiences: [POD_LEAD, LGA, ADMIN],
      icon: WHATS_NEW_ICONS.CALENDAR,
      title: "Team Calendar",
      items: [
        "Switch views and weeks from the same toolbar. Filters and view settings sit above the calendar, and the color key sits below it.",
        "See how many callers have booked in the Callers booked card.",
      ],
      link: { label: "Open Calendar", href: Router.manageCalendar() },
    },
    {
      id: "pods",
      audiences: [LGA, ADMIN],
      icon: WHATS_NEW_ICONS.TEAM,
      title: "Pods",
      items: [
        "Pods opens on a workspace's pods, so you can see the list before choosing another workspace.",
      ],
      link: { label: "Open Pods", href: Router.manageAdmin("pods") },
    },
    {
      id: "admin",
      audiences: [ADMIN],
      icon: WHATS_NEW_ICONS.SHIELD,
      title: "Admin",
      items: [
        "The page title and tabs stay together above Roles and Pods, including while the list loads or needs a retry.",
      ],
      link: { label: "Open Roles", href: Router.manageAdmin("roles") },
    },
  ],
};
